import styled from "@emotion/styled";

export const PageWrapper = styled.div`
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
  font-family: Poppins;
`;

export const PageWrapperT1 = styled(PageWrapper)`
  padding: 20px;
`;
export const PageWrapperT2 = styled(PageWrapper)`
  padding: 20px 24px;
`;
export const PageWrapperT3 = styled(PageWrapper)`
  padding: 20px 35px;
  position: relative;
`;
export const PageWrapperT4 = styled(PageWrapper)`
  padding: 20px 24px;
  background-color: #e3e9ff;
  height: calc(100vh - 60px);
`;

export const PageWrapperT5 = styled(PageWrapper)`
  padding: 20px 24px;
  height: calc(100vh - 60px);
`;

